// extracted by mini-css-extract-plugin
export default {"header":"Default_header__u2Vz5","main":"Default_main__53q3Y","footer":"Default_footer__S+x6B"};